export default {
    page_title: "Kevi | Base de Contatos",
    base_name: "Base de Contatos",
    export: "Exportar",
    create_segment: "Criar segmento",
    add_contact: "Adicionar Contato",
    import: "Importar",
    import_question: "Que informacao deseja importar?",
    sales: "Vendas",
    clients: "Clientes",
    columns: {
        name: "Nome",
        phone: "Telefone",
        birthday: "Aniversario",
        average_ticket: "Ticket Medio",
        spent: "Gastos",
        orders_made: "Pedidos Feitos",
        email: "E-mail",
        id: "ID",
        external_id: "ID Externo",
    },
    open_contact_aria: "Abrir contato {0} {1}",
    years_old: "anos",
    not_informed: "Nao informada",
    details: "Detalhes",
    filters: {
        bought_in_period: "Comprou no periodo",
        registration_date: "Data de cadastro",
        search: "Nome, telefone, e-mail ou codigo",
        client_segment: "Segmento do cliente",
        first_order_period: "Periodo do primeiro pedido",
    },
    empty_state: {
        title: "Base de Contatos",
        subtitle: "Voce ainda nao tem nenhum cliente cadastrado",
    },
    export_headers: {
        name: "Nome",
        phone: "Telefone",
        birthday: "Aniversario",
        age: "Idade",
        email: "E-mail",
        average_ticket: "Ticket Medio (R$)",
        spent: "R$ Gastos",
        orders_made: "Pedidos Feitos",
        id: "Id",
        external_id: "Id externo",
    },
    detail: {
        confirm_delete_order_title: "Tem certeza que deseja deletar o Pedido?",
        confirm_delete_custom_event_title:
            "Tem certeza que deseja deletar o Evento Personalizado",
        confirm_delete_event_body:
            "Este evento será removido assim que confirmado.",
        edit_order: "Editar Pedido",
        made_order_of: "Realizou um pedido de",
        register_order: "Registrar Pedido",
        back: "Voltar",
        more_segments: "mais {0}",
        see_less: "ver menos",
        insights: "Insights",
        integration_id: "ID Integração:",
        subscribed: "Inscrito:",
        sms: "SMS",
        whatsapp: "WhatsApp",
        total_quotations: "Número de Orçamentos :",
        total_points: "Total de Pontos :",
        total_orders: "Número de compras:",
        average_ticket: "Ticket Médio:",
        clv: "Gasto Acumulado (CLV):",
        next_order_prediction: "Previsão próxima compra:",
        replenishment: "Reposição ({0}):",
        view_one_opinion: "Ver 1 opinião.",
        view_many_opinions: "Ver {0} opiniões.",
        edit: "Editar",
        timeline: "Linha do tempo",
        notes: "Observações",
        page_title: "Kevi | Detalhe do cliente",
        phonetrack_call: "Ligação via phonetrack",
        audio_not_supported_prefix:
            "Seu navegador não suporta o elemento",
        utm_source: "Utm source:",
        utm_medium: "Utm medium:",
        utm_campaign: "Utm campaign:",
        gclid: "Gclid:",
        campaign_interaction: "Interagiu com campanha",
        left_feedback: "Deixou opinião",
        with_average: "com média",
        using_form: "Usando o formulário:",
        redeemed_bonus_of: "Resgatou o bônus de",
        exchanged: "Trocou",
        for: "por",
        left_segment: "Saiu do",
        entered_segment: "Entrou no",
        segment: "segmento",
        added: "Adicionamos",
        removed: "Removemos",
        automation: "Automação:",
        generated_coupon_for: "Gerado cupom para",
        code: "código",
        delivery: "Delivery",
        order_cancelled: "Pedido cancelado",
        status: "Status:",
        products: "Produtos:",
        earned: "Ganhou:",
        send_now: "Enviar Agora",
        status_failed: "Falha no envio",
        status_failed_with_period: "Falha no envio.",
        status_scheduled: "Agendado",
        status_processing: "Processando",
        status_accepted: "Aceito",
        status_sent: "Enviado",
        reason: "Motivo:",
        quotation_status_expired: "Expirado",
        quotation_status_rejected: "Rejeitado",
        loading_preview: "Carregando preview...",
        registered_event: "registrou o evento",
        branch: "Filial:",
        task_completed: "Tarefa concluída",
        due_date: "Data de Vencimento:",
        suggested_message: "Mensagem sugerida:",
        created_task: "Criou a tarefa",
        quotation: "Orçamento",
        has_quotation_of: "Possui um orçamento de",
        order_placed_on: "Pedido realizado em",
        add_note_placeholder: "Adicionar observação...",
        add: "Adicionar",
        in_a: "em uma",
        opinion: "opinião",
        delete_client_title: "Deseja deletar esse cliente?",
        delete_client_body:
            "Essa ação é irreversível e irá deletar permanentemente esse cliente e todos os dados à ele vinculados.",
        delete_client_button: "Deletar Cliente",
        notification_sent_success: "Notificação enviada com sucesso",
        notification_send_error_prefix: "Erro ao enviar notificação: ",
        unknown_error: "Erro desconhecido",
        fail_reason_not_subscribed: "Cliente não inscrito",
        fail_reason_not_enough_credits: "Falta de créditos",
        client_deleted_success: "Cliente deletado com sucesso!",
        client_delete_error: "Erro ao deletar cliente.",
        point_singular: " ponto",
        point_plural: " pontos",
        ai_error: "Erro ao obter resposta da IA.",
        not_found: "Não encontrado",
        storage_load_error: "Não foi possível carregar o estado dos grupos do localStorage",
        storage_save_error: "Não foi possível salvar o estado dos grupos no localStorage",
    },
    deletion: {
        started: "Deleção de clientes iniciada!",
        error: "Erro ao iniciar deleção de clientes",
    },
    basic: {
        subscribed_channels: "Canais inscritos",
        close: "Fechar",
        save: "Salvar",
        first_name: "Nome",
        last_name: "Sobrenome",
        birthdate: "Data de Nascimento",
        register_event: "Registrar evento",
        run_manual_automation: "Disparar automação",
        create_task: "Criar tarefa",
        include_orders: "Incluir Pedidos",
        create_single_form_link: "Criar Link de Formulário Único",
        manage_points: "Incluir/Remover Pontos",
        segments: "Segmentos",
        see_more: "Ver mais",
        search: "Buscar",
        total_segments: "Total de segmentos: {0}",
        delete: "Excluir",
    },
    manual_automation: {
        title: "Disparar automação",
        automation_label: "Qual automação?",
        automation_placeholder: "Selecione a automação",
        date_placeholder: "Selecione a data",
        empty: "Nenhuma automação de disparo manual ativa.",
        cancel: "Cancelar",
        confirm: "Disparar",
        success: "Automação disparada com sucesso.",
        error: "Não foi possível disparar a automação.",
    },
    modals: {
        delete_client_title: "Excluir Cliente",
        delete_info_irreversible: "Deletar o cliente da base é uma ação irreversível.",
        delete_info_will_delete: "Junto com o cliente iremos deletar:",
        delete_info_all_sales: "Todas as suas vendas",
        delete_info_all_tasks: "Todas as suas tarefas",
        delete_info_all_messages: "Todas as mensagens enviadas",
        delete_info_all_records: "Qualquer registro vinculado a esse cliente",
        delete_info_permanent: "Essa exclusão é permanente.",
        delete_info_inconsistency: "Deletar o cliente pode gerar inconsistência nos dados",
        delete_info_inconsistency_detail: ", a partir do momento que você deleta o cliente, os relatórios da Kevi não refletirão mais os mesmos números do seu ERP.",
        delete_info_confirm_phrase_placeholder: "EXCLUIR {0} PERMANENTEMENTE",
        delete_client_confirm: "Tem certeza que deseja excluir este cliente?",
        delete_client_body: "Todos os dados deste cliente serão removidos permanentemente. Esta ação não pode ser desfeita.",
        delete_client_button: "Excluir",
        client_updated_success: "Cliente atualizado com sucesso!",
        client_updated_error: "Erro ao atualizar cliente.",
        manage_points: "Incluir/Remover pontos",
        current_value: "Valor Atual:",
        changed_value: "Valor alterado:",
        close: "Fechar",
        apply: "Aplicar",
        create_single_form_link: "Criar Link de Formulário Único",
        generated_link: "Link Gerado",
        form: "Formulário",
        select_form: "Selecione o formulário",
        generate_link: "Gerar Link",
        create_task_title: "Criar uma Tarefa",
        title: "Título",
        task_title_placeholder: "Dê um titulo para essa tarefa",
        client: "Cliente",
        assignee: "Responsável",
        select_assignee: "Selecione um responsável",
        due_date: "Prazo",
        select_due_date: "Selecione um prazo",
        description: "Descrição",
        task_description_placeholder: "Descreva essa tarefa",
        cancel: "Cancelar",
        create_task_action: "Criar tarefa",
        edit_data: "Editar Dados",
        new_contact: "Novo Contato",
        create_contact: "Criar Contato",
        subscriptions: "Canais de Envio",
        main_info: "Informações Principais",
        integration_id: "ID Integração",
        first_name: "Primeiro nome",
        mobile: "Celular",
        birthdate_placeholder: "dd/mm/yyyy",
        client_created_success: "Contato criado com sucesso!",
        client_updated_success: "Contato atualizado com sucesso!",
    },
    timeline: {
        search: "Buscar",
        open_all: "Abrir todos",
        close_all: "Fechar todos",
        showing_range: "Exibindo {0}-{1} de {2}",
        delete: "Deletar",
        order_created: "Pedido realizado",
        order_fields: "Campos do Pedido:",
        order_created_label: "Pedido realizado:",
        email_subject: "Assunto:",
        whatsapp_message: "mensagem por Whatsapp",
        sms_message: "mensagem por SMS",
        rcs_message: "mensagem por RCS",
        visited_site_from: "Visitou o site a partir de",
        ad: "um anúncio",
        generated_coupon: "Gerado cupom",
        with_code: "com o código",
        earned_points: "Ganhou",
        lost_points: "Perdeu",
        ai_basic: "Básico",
        ai_advanced: "Avançado",
        ai_generated_content: "IA gerou conteúdo",
        view_execution_details: "Ver detalhes da execução",
        instruction: "Instrução:",
        tool_calls: "Chamadas de ferramentas ({0})",
        arguments: "Argumentos:",
        result: "Resultado:",
        unknown_event: "Evento desconhecido:",
        field_update_failed: "Falha ao atualizar campos do cliente",
        field_update_failed_reason: "Motivo:",
        empty_title: "Nenhum evento encontrado",
        empty_subtitle:
            "Nenhuma interação registrada para este cliente com os filtros atuais.",
        waiting: "Aguardando",
        scheduled_feminine: "Agendada",
        failed_of: "Falha de",
        received: "Recebeu",
        pending: "Pendente",
        sent_to_another_contact: "Enviado para",
        sent_to_another_contact_help:
            "Esta notificação foi enviada para um contato diferente do telefone ou e-mail cadastrado neste cliente.",
    },
    insights: {
        ai_title: "Kevi IA no seu atendimento",
        ai_subtitle:
            "Peça resumos, entenda o sentimento do cliente e receba sugestões de resposta em tempo real.",
        type_message: "Digite aqui sua mensagem",
        send: "Enviar",
        purchases: "Compras",
        first_purchase: "Primeira compra",
        last_purchase: "Última compra",
        most_purchased_item: "Item mais comprado",
        cumulative_spend: "Gasto acumulado",
        total_purchases: "Total de compras",
        replenishment: "Reposição",
        replenishment_overdue: "Há {0} dias",
        replenishment_today: "Hoje",
        replenishment_tomorrow: "Amanhã",
        replenishment_in_days: "Em {0} dias",
        validity_range: "Validade entre: {0} a {1}",
        periods: {
            "30_days": "30 dias",
            "90_days": "90 dias",
            "180_days": "180 dias",
            "1_year": "1 ano",
            "all_time": "Todo período",
        },
        view_all: "Ver todos",
        view_latest: "Ver últimos",
        with_stock: "Com estoque",
        without_stock: "Sem estoque",
        communications: "Comunicações",
        contacts: "Contatos",
        last_contact_date: "Data do último contato",
        first_contact_date: "Data do primeiro contato",
        points: "Pontos",
        available_points: "Pontos disponíveis",
        total_accumulated: "Total acumulado",
        points_used: "Pontos usados",
        reward: "Recompensa",
        forms: "Respostas",
        create_unique_link: "Criar link único",
        latest_forms: "Últimas respostas",
        view: "Visualizar",
        answered: "Respondido",
        not_answered: "Não Respondido",
        no_forms_sent: "Nenhuma resposta",
        no_forms_sent_subtitle:
            "Quando o cliente responder um formulário, a resposta aparece aqui. Você também pode criar um link único.",
        tasks: "Tarefas",
        generated: "Geradas",
        completed: "Concluídas",
        conversion: "Conversão",
        completed_on_time: "Concluídas no prazo",
        latest_tasks: "Últimas tarefas",
        completed_single: "Concluída",
        pending_single: "Pendente",
        kevi_coupons: "Cupons Kevi",
        active_coupons: "Cupons Ativos",
        used_coupons: "Cupons usados",
        expired_coupons: "Cupons expirados",
        latest_coupons: "Últimos cupons",
        added: "Adicionado",
        removed: "Removido",
        used: "Utilizado",
        expired: "Vencido",
        available: "Disponível",
        pending_plural: "Pendentes",
        completed_plural: "Concluídas",
    },
    journey: {
        back: "Voltar",
        title: "Jornada do cliente",
        move_to_which_board: "Para qual quadro quer mover?",
        move_to_which_stage: "Mover para qual etapa?",
        cancel: "Cancelar",
        enter: "Entrar",
        move_success: "Cliente movido com sucesso",
        outside_journey: "Fora da Jornada: {0}",
        move_action: "Mover {0}",
        move_to_action: "Mover {0} para {1}",
        move_completed_success: "Movimentação realizada com sucesso!",
    },
    leads: {
        title: "Leads",
        add: "Adicionar",
        no_leads_found: "Nenhum lead encontrado",
        page_title: "Kevi | Lista de Leads",
    },
    importer: {
        sending_data: "Enviando dados, isso pode levar alguns minutos...",
        import_success: "Importação concluída com sucesso!",
        import_error: "Ocorreu um erro ao processar a importação.",
        queued_message: "Importação enviada! Ela será processada em segundo plano.",
        queued_link: "Acompanhar no histórico de importações",
        cancel: "Cancelar",
        import: "Importar",
        close: "Fechar",
        file_size_error: "O arquivo excede o tamanho máximo de {0} KB.",
    },
    notes: {
        add_note: "Adicionar observação",
        markdown_hint: "Use Markdown para formatar seu texto.",
        note_placeholder: "Digite sua observação",
        save_note: "Salvar anotação",
        client_notes: "Observações do cliente",
        no_notes: "Nenhuma observação ainda",
        no_notes_subtitle: "Registre informações importantes sobre o cliente para facilitar atendimentos futuros.",
        create_first_note: "Criar primeira observação",
        save_error: "Erro ao salvar: {0}",
    },
};
